module.exports = __webpack_public_path__ + "assets/227205d09853a03fcf354152619dbfdb.png";